import moment from "moment";
import React, { useMemo } from "react";
import { useGroupChatContext } from "../../context/groupchatContext";
import { titleWithoutUnderscore } from "../../helpers/utility";
import AttachmentContainer from "../../pages/groupChat/attachmentContainer";
import useSendPdfToChat from "../../hooks/useSendPdfToChat";

export const EventMessage = ({msg, isLoggedInUser}) => {


    const {sendPdfToChat, isSending} = useSendPdfToChat();
  
    return (
        <div className={`rounded-md ${isLoggedInUser() ? 'bg-blue-100': 'bg-white border' }  p-2 shadow`}>
            <div className={`text-gray-800 text-start`}>
                <h1 className={`capitalize font-bold border-b py-1 px-2 rounded-t-md`}>{titleWithoutUnderscore(msg.message?.event_type)}</h1>
                <div className={`p-2 rounded-b-md`}>
                    {msg.message.data?.date_of_service && (
                        <p className="mb-1">DOS: {moment(msg.message.data?.date_of_service).format('MM/DD/YYYY hh:mm A')}</p>
                    )}
                    {msg.message.data?.serial_number && (
                        <p>Encounter number: {msg.message.data?.serial_number}</p>
                    )}
                </div>
            </div>
            {msg.message.media?.length ?
                <div className="mt-2">
                    <AttachmentContainer data={{files:msg.message?.media}} openInEditor={msg.message?.media[0]?.mime_type === 'application/pdf'} callBackFun={sendPdfToChat} includeOrigAttachId stackFiles />
                </div>
                : null
            }
        </div>
    );
};